import type { Settings as LayoutSettings } from '@ant-design/pro-components';
import type { RequestConfig, RunTimeLayoutConfig } from '@umijs/max';
import { history } from '@umijs/max';
import React from 'react';
import { withPublicPath } from './../config/appPath';

import { AvatarDropdown, AvatarName, Footer } from '@/components';
import { AuthProvider } from '@/context/AuthContext';
import { mapUserInfo, queryCurrentUser } from '@/services/auth';
import { getAccessToken } from '@/services/request';
import { stripAppBase } from '../config/appPath';
import defaultSettings from '../config/defaultSettings';
import { errorConfig } from './requestErrorConfig';
import '@ant-design/v5-patch-for-react-19';
const loginPath = '/user/login';

export async function getInitialState(): Promise<{
  settings?: Partial<LayoutSettings>;
  currentUser?: API.CurrentUser;
  loading?: boolean;
  fetchUserInfo?: () => Promise<API.CurrentUser | undefined>;
}> {
  const fetchUserInfo = async () => {
    const token = getAccessToken();

    if (!token) {
      return undefined;
    }

    try {
      const userInfo = await queryCurrentUser();
      return mapUserInfo(userInfo, userInfo?.username || '');
    } catch (_error) {
      history.push(loginPath);
      return undefined;
    }
  };

  const { location } = history;
  if (stripAppBase(location.pathname) !== loginPath) {
    const currentUser = await fetchUserInfo();
    return {
      fetchUserInfo,
      currentUser,
      settings: defaultSettings as Partial<LayoutSettings>,
    };
  }

  return {
    fetchUserInfo,
    settings: defaultSettings as Partial<LayoutSettings>,
  };
}

export const layout: RunTimeLayoutConfig = ({ initialState }) => {
  return {
    avatarProps: {
      logo: <img src={withPublicPath('benhealth.png')}
                 style={{ height: 48 }} />,
      src: initialState?.currentUser?.avatar,
      title: <AvatarName />,
      render: (_, avatarChildren) => {
        return <AvatarDropdown>{avatarChildren}</AvatarDropdown>;
      },
    },
    waterMarkProps: {
      content: initialState?.currentUser?.name,
    },
    footerRender: () => <Footer />,
    onPageChange: () => {
      const { location } = history;
      if (!initialState?.currentUser && stripAppBase(location.pathname) !== loginPath) {
        history.push(loginPath);
      }
    },
    menuHeaderRender: undefined,
    childrenRender: (children) => {
      return <AuthProvider>{children}</AuthProvider>;
    },
    ...initialState?.settings,
  };
};

export const request: RequestConfig = {
  ...errorConfig,
};
